<template>
  <div class="zmanim-list-header__container">
    <div class="zmanim-list-header__text">
      <div class="zmanim-list-header__subtitle">
        {{ subtitle }}
      </div>
      <div class="zmanim-list-header__title">
        {{ title }}
      </div>
    </div>
    <div class="zmanim-list-header__backdrop" />
  </div>
</template>

<script>
export default {
  name: 'ZmanimListHeader',
  props: {
    title: {
      type: String,
      default: 'Title'
    },
    subtitle: {
      type: String,
      default: 'Subtitle'
    }
  }
}
</script>

<style scoped>
.zmanim-list-header__container {
  display: flex;
  flex-shrink: 0;
  flex-grow: 1;
  flex-direction: row;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: center;
  height: 5rem;
}

.zmanim-list-header__text {
  display: flex;
  flex-direction: column;
  flex-grow: 0;
  text-align: left;
  margin: 0 1.5rem;
}
.zmanim-list-header__title {
  font-family: "Avenir-Heavy", "Helvetica", "sans-serif";
  font-size: 1.5rem;
  color: #4a4a4a;
  letter-spacing: -0.82px;
  margin: 0;
  z-index: 3;
}

.zmanim-list-header__subtitle {
  font-family: "Avenir-Medium", "Helvetica", "sans-serif";
  font-size: 0.875rem;
  color: #9b9b9b;
  letter-spacing: -0.82px;
  z-index: 3;
}

.zmanim-list-header__backdrop {
  position: absolute;
  top: 0;
  left: 0;
  height: 5rem;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.9);
}
</style>
